import React from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'

import { Navigate } from '@lib/react-router-dom'

import { useSignup } from '@context/SignupContext'

import { useLeadOTPVerification } from '@hooks/useLeadOTPVerification'
import { useScrollToTop } from '@hooks/useScrollToTop'

import { Box } from '@shared/components/Box/Box'

import { VerifyLeadUsingOTP } from '../verifyLeadUsingOTP/VerifyLeadUsingOTP'

export const ResendEmailPage: React.FC = () => {
  useScrollToTop()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const { signupData } = useSignup()

  const { leadId: stateLeadId } = (location.state as { leadId?: string }) || {}

  const leadId = signupData.lead?.id ?? searchParams.get('leadId') ?? stateLeadId ?? null

  const token = searchParams.get('token')

  const email = signupData.values?.email?.trim() || signupData.lead?.email || ''

  const hasRecoveryContext = Boolean(leadId || email)

  const {
    resolvedEmail,
    resendLoading,
    continueLoading,
    handleResend,
    handleVerifyCode,
    handleContinue,
  } = useLeadOTPVerification({ leadId, email, token })

  if (!hasRecoveryContext) {
    return <Navigate to='/sign-up/personal-details/basic/' replace />
  }

  return (
    <Box flex align='center' justify='center' fullWidth fullHeight wrap>
      <VerifyLeadUsingOTP
        email={resolvedEmail}
        onResend={handleResend}
        onVerifyCode={handleVerifyCode}
        onContinue={handleContinue}
        resendLoading={resendLoading}
        continueLoading={continueLoading}
      />
    </Box>
  )
}
